import { useModalContext } from '@/context/ModalsContext';

export const LocationSection = () => {
  const { setIsModalOpened } = useModalContext();

  return (
    <section className="text-left">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="mb-6 text-4xl font-bold text-gray-900">
            Service Areas
          </h2>
          <p className="mx-auto max-w-4xl text-lg leading-relaxed text-gray-600">
            We provide fast, reliable, and expert services across San Diego and
            surrounding communities. Are you in the heart of the city or nestled
            in a quiet suburban neighborhood? We are ready to bring comfort
            right to your doorstep. Don&apos;t see your location on the list?
            Feel free to contact us to check.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-xl border border-blue-200 bg-gradient-to-br from-blue-50 to-blue-100 p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl">
            <div className="mb-6 flex items-center">
              <div className="justify-content center mr-4 flex size-12 items-center rounded-full bg-blue-500 shadow-md">
                <span className="mx-auto text-sm font-bold text-white">NC</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                North County Coastal
              </h3>
            </div>
            <div className="">
              <div className="text-sm font-medium text-gray-700">Del Mar</div>
              <div className="text-sm font-medium text-gray-700">
                Carmel Valley
              </div>
              <div className="text-sm font-medium text-gray-700">
                Olivenhain
              </div>
              <div className="text-sm font-medium text-gray-700">
                Rancho Santa Fe
              </div>
              <div className="text-sm font-medium text-gray-700">
                Solana Beach
              </div>
              <div className="text-sm font-medium text-gray-700">
                Cardiff-By-The-Sea
              </div>
              <div className="text-sm font-medium text-gray-700">Encinitas</div>
              <div className="text-sm font-medium text-gray-700">Leucadia</div>
              <div className="text-sm font-medium text-gray-700">La Costa</div>
              <div className="text-sm font-medium text-gray-700">
                San Elijo Hills
              </div>
              <div className="text-sm font-medium text-gray-700">Carlsbad</div>
              <div className="text-sm font-medium text-gray-700">Oceanside</div>
            </div>
          </div>

          <div className="rounded-xl border border-green-200 bg-gradient-to-br from-green-50 to-green-100 p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl">
            <div className="mb-6 flex items-center">
              <div className="mr-4 flex size-12 items-center justify-center rounded-full bg-green-500 shadow-md">
                <span className="text-sm font-bold text-white">NI</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                North County Inland
              </h3>
            </div>
            <div className="">
              <div className="text-sm font-medium text-gray-700">Vista</div>
              <div className="text-sm font-medium text-gray-700">
                San Marcos
              </div>
              <div className="text-sm font-medium text-gray-700">Ramona</div>
              <div className="text-sm font-medium text-gray-700">Escondido</div>
              <div className="text-sm font-medium text-gray-700">
                Rancho Bernardo
              </div>
              <div className="text-sm font-medium text-gray-700">Poway</div>
              <div className="col-span-2 text-sm font-medium text-gray-700">
                Carmel Mt Ranch & Sabre Springs
              </div>
              <div className="text-sm font-medium text-gray-700">4S Ranch</div>
              <div className="text-sm font-medium text-gray-700">Santaluz</div>
              <div className="col-span-2 text-sm font-medium text-gray-700">
                Rancho Penasquitos
              </div>
              <div className="text-sm font-medium text-gray-700">
                Torrey Highlands
              </div>
              <div className="text-sm font-medium text-gray-700">
                Scripps Ranch
              </div>
              <div className="text-sm font-medium text-gray-700">Mira Mesa</div>
            </div>
          </div>

          <div className="rounded-xl border border-teal-200 bg-gradient-to-br from-teal-50 to-teal-100 p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl">
            <div className="mb-6 flex items-center">
              <div className="mr-4 flex size-12 items-center justify-center rounded-full bg-teal-500 shadow-md">
                <span className="text-sm font-bold text-white">SC</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                San Diego Coastal
              </h3>
            </div>
            <div className="">
              <div className="text-sm font-medium text-gray-700">La Jolla</div>
              <div className="col-span-2 text-sm font-medium text-gray-700">
                University City & UTC
              </div>
              <div className="text-sm font-medium text-gray-700">
                Clairemont
              </div>
              <div className="text-sm font-medium text-gray-700">
                Pacific Beach
              </div>
              <div className="text-sm font-medium text-gray-700">
                Mission Beach
              </div>
              <div className="text-sm font-medium text-gray-700">
                Ocean Beach
              </div>
              <div className="text-sm font-medium text-gray-700">
                Point Loma
              </div>
              <div className="col-span-2 text-sm font-medium text-gray-700">
                Old Town & Bay Park
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-purple-200 bg-gradient-to-br from-purple-50 to-purple-100 p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl">
            <div className="mb-6 flex items-center">
              <div className="mr-4 flex size-12 items-center justify-center rounded-full bg-purple-500 shadow-md">
                <span className="text-sm font-bold text-white">DT</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                Downtown San Diego
              </h3>
            </div>
            <div className="">
              <div className="text-sm font-medium text-gray-700">
                Little Italy
              </div>
              <div className="text-sm font-medium text-gray-700">Cortez</div>
              <div className="text-sm font-medium text-gray-700">Columbia</div>
              <div className="text-sm font-medium text-gray-700">Core</div>
              <div className="text-sm font-medium text-gray-700">
                Horton Plaza
              </div>
              <div className="text-sm font-medium text-gray-700">Gaslamp</div>
              <div className="text-sm font-medium text-gray-700">
                Marina District
              </div>
              <div className="text-sm font-medium text-gray-700">
                East Village
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-orange-200 bg-gradient-to-br from-orange-50 to-orange-100 p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl">
            <div className="mb-6 flex items-center">
              <div className="mr-4 flex size-12 items-center justify-center rounded-full bg-orange-500 shadow-md">
                <span className="text-sm font-bold text-white">CE</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                San Diego Central
              </h3>
            </div>
            <div className="">
              <div className="text-sm font-medium text-gray-700">
                Tierrasanta
              </div>
              <div className="text-sm font-medium text-gray-700">
                Mission Valley
              </div>
              <div className="text-sm font-medium text-gray-700">
                Mission Hills
              </div>
              <div className="text-sm font-medium text-gray-700">
                North Park
              </div>
              <div className="text-sm font-medium text-gray-700">
                Sorrento Mesa
              </div>
              <div className="text-sm font-medium text-gray-700">
                San Carlos
              </div>
              <div className="text-sm font-medium text-gray-700">Del Cerro</div>
              <div className="col-span-2 text-sm font-medium text-gray-700">
                College & Talmadge
              </div>
              <div className="text-sm font-medium text-gray-700">
                Kensington
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-red-200 bg-gradient-to-br from-red-50 to-red-100 p-6 shadow-lg transition-shadow duration-300 hover:shadow-xl">
            <div className="mb-6 flex items-center">
              <div className="mr-4 flex size-12 items-center justify-center rounded-full bg-red-500 shadow-md">
                <span className="text-sm font-bold text-white">ES</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                East & South County
              </h3>
            </div>

            <div className="flex justify-between">
              <div className="mb-4">
                <h4 className="mb-2 text-sm font-bold uppercase tracking-wide text-gray-800">
                  East County:
                </h4>
                <div className="">
                  <div className="text-sm font-medium text-gray-700">
                    El Cajon
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Santee
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Alpine
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Spring Valley
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    La Mesa
                  </div>
                </div>
              </div>

              <div>
                <h4 className="mb-2 text-sm font-bold uppercase tracking-wide text-gray-800">
                  South County:
                </h4>
                <div className="">
                  <div className="text-sm font-medium text-gray-700">
                    Chula Vista
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    East Lake
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Coronado
                  </div>
                  <div className="text-sm font-medium text-gray-700">
                    Bonita
                  </div>
                  <div className="col-span-2 text-sm font-medium text-gray-700">
                    Imperial Beach
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="mx-auto max-w-3xl rounded-2xl border border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100 p-8 shadow-lg">
            <div className="mb-4 flex items-center justify-center">
              <div className="mr-4 flex size-16 items-center justify-center rounded-full bg-orange-500 shadow-lg">
                <svg
                  className="size-8 text-white"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">
                Don&apos;t See Your Location?
              </h3>
            </div>
            <p className="mb-6 text-lg leading-relaxed text-gray-600">
              We may still be able to serve your area. Contact us to check
              availability in your neighborhood and get a free consultation.
            </p>
            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
              <button
                onClick={() => setIsModalOpened(true)}
                className="rounded-lg bg-orange-500 px-8 py-3 text-lg font-semibold text-white shadow-lg transition-colors duration-300 hover:bg-orange-600 hover:shadow-xl"
              >
                Contact Us Today
              </button>
              <a
                href="tel:(619)349-4397"
                className="flex items-center space-x-2 text-gray-700 transition-colors duration-300 hover:text-orange-500"
              >
                <svg className="size-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
                <span className="text-lg font-semibold">(619) 349-4397</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
